/**
 * Demo adventure helpers — rooms start empty until GM loads scene.v1.json.
 * TOKEN_SIZE re-exported from sceneV1 for drag geometry.
 */

export { TOKEN_SIZE } from "./sceneV1";

/** Polished in-repo demo adventure (S4) — assets under /demo-adventure/. */
export const DEMO_ADVENTURE_URL = "/scenes/ember-crossing.v1.json";

/** @deprecated Prefer DEMO_ADVENTURE_URL; kept for S3 sample path. */
export const SAMPLE_SCENE_URL = DEMO_ADVENTURE_URL;
